<div id="home" class="main-banner main-banner-one">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-7 col-md-12">
                <div class="main-banner-content">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="content">
                                <h1>{{ "hero.name" | translate }}</h1>
                                <h3>{{ "hero.tagline" | translate }}</h3>
                                <p>
                                    {{ "hero.intro" | translate }}
                                </p>
                                <a
                                    href="#contact"
                                    (click)="
                                        analyticsService.onContactScroll('hero')
                                    "
                                    class="default-btn"
                                >
                                    {{ "hero.letsTalk" | translate
                                    }}<span></span>
                                </a>
                                <a
                                    href="#projects"
                                    (click)="
                                        analyticsService.onProjectScroll('hero')
                                    "
                                    class="optional-btn"
                                >
                                    {{ "hero.viewWork" | translate
                                    }}<span></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-md-12">
                <div class="banner-image mbanner-bg-one">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="animate-banner-image">
                                <img
                                    src="assets/img/profile-hero.png"
                                    [alt]="'hero.profileAlt' | translate"
                                />
                            </div>
                        </div>
                    </div>
                    <img
                        src="assets/img/profile-hero.png"
                        class="mbanner-img"
                        [alt]="'hero.profileAlt' | translate"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="shape20" aria-hidden="true">
        <img src="assets/img/shape/shape19.png" alt="image" loading="lazy" />
    </div>
    <div class="shape21" aria-hidden="true">
        <img src="assets/img/shape/shape20.png" alt="image" loading="lazy" />
    </div>
    <div class="shape19" aria-hidden="true">
        <img src="assets/img/shape/shape18.png" alt="image" loading="lazy" />
    </div>
    <div class="shape22" aria-hidden="true">
        <img src="assets/img/shape/shape21.png" alt="image" loading="lazy" />
    </div>
    <div class="shape23" aria-hidden="true">
        <img src="assets/img/shape/shape22.svg" alt="image" loading="lazy" />
    </div>
    <div class="shape24" aria-hidden="true">
        <img src="assets/img/shape/shape23.png" alt="image" loading="lazy" />
    </div>
    <div class="shape26" aria-hidden="true">
        <img src="assets/img/shape/shape25.png" alt="image" loading="lazy" />
    </div>
</div>

<div id="skills" class="features-card-section pt-100 pb-70 bg-f8fbfa">
    <div class="container">
        <div class="row">
            <div
                class="mb-4 mb-lg-0 col-lg-3 col-sm-6 col-md-6 wow animate__animated animate__fadeInUp"
                data-wow-delay=".2s"
            >
                <div class="single-features-card tx-center">
                    <i class="bx bx-code-alt"></i>
                    <h3>{{ "skills.webIntegration.title" | translate }}</h3>
                    <p>
                        {{ "skills.webIntegration.text" | translate }}
                    </p>
                </div>
            </div>
            <div
                class="mb-4 mb-lg-0 col-lg-3 col-sm-6 col-md-6 wow animate__animated animate__fadeInUp"
                data-wow-delay=".4s"
            >
                <div class="single-features-card tx-center">
                    <i class="bx bx-devices"></i>
                    <h3>{{ "skills.responsive.title" | translate }}</h3>
                    <p>
                        {{ "skills.responsive.text" | translate }}
                    </p>
                </div>
            </div>
            <div
                class="mb-4 mb-lg-0 col-lg-3 col-sm-6 col-md-6 wow animate__animated animate__fadeInUp"
                data-wow-delay=".6s"
            >
                <div class="single-features-card tx-center">
                    <i class="bx bx-window-alt"></i>
                    <h3>{{ "skills.webApp.title" | translate }}</h3>
                    <p>
                        {{ "skills.webApp.text" | translate }}
                    </p>
                </div>
            </div>
            <div
                class="mb-4 mb-lg-0 col-lg-3 col-sm-6 col-md-6 wow animate__animated animate__fadeInUp"
                data-wow-delay=".8s"
            >
                <div class="single-features-card tx-center">
                    <i class="bx bx-cloud-upload"></i>
                    <h3>{{ "skills.saas.title" | translate }}</h3>
                    <p>
                        {{ "skills.saas.text" | translate }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<section id="tech" class="services-area bg-right-shape ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-content it-service-content">
                <div class="content left-content">
                    <h2>{{ "tech.frontend.title" | translate }}</h2>
                    <p>
                        {{ "tech.frontend.intro" | translate }}
                    </p>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.frontend.angular" | translate }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.frontend.material" | translate }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.frontend.bootstrap" | translate }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.frontend.responsiveUi" | translate }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.frontend.pwa" | translate }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.frontend.css" | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="services-image wow animate__animated animate__fadeInRight"
                data-wow-delay=".3s"
            >
                <div class="image">
                    <img
                        src="assets/img/skills/frontend-stack-display-development.jpg"
                        [alt]="'tech.frontend.imgAlt' | translate"
                    />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="services-area bg-left-color bg-left-shape bg-f4f6fc ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div
                class="services-image wow animate__animated animate__fadeInLeft"
                data-wow-delay=".3s"
            >
                <div class="image">
                    <img
                        src="assets/img/skills/backend-stack-display-development.jpg"
                        [alt]="'tech.backend.imgAlt' | translate"
                    />
                </div>
            </div>
            <div class="services-content it-service-content">
                <div class="content">
                    <h2>{{ "tech.backend.title" | translate }}</h2>
                    <p>
                        {{ "tech.backend.intro" | translate }}
                    </p>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.backend.express" | translate }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.backend.nestjs" | translate }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.backend.sql" | translate }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.backend.docker" | translate }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.backend.githubWorkflow" | translate }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class="bx bxs-badge-check"></i>
                                {{ "tech.backend.nginx" | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="features-area pt-100 pb-70 bg-f4f6fc">
    <div class="container">
        <div class="section-title">
            <h2>{{ "specialized.sectionTitle" | translate }}</h2>
        </div>
        <div class="row">
            <div class="mb-4 col-lg-4 col-md-6">
                <div
                    class="features-box-one wow animate__animated animate__fadeInLeft"
                    data-wow-delay=".2s"
                >
                    <i class="bx bx-customize bg-13c4a1"></i>
                    <h3>{{ "specialized.api.title" | translate }}</h3>
                    <p>
                        {{ "specialized.api.text" | translate }}
                    </p>
                </div>
            </div>
            <div class="mb-4 col-lg-4 col-md-6">
                <div
                    class="features-box-one wow animate__animated animate__fadeInLeft"
                    data-wow-delay=".4s"
                >
                    <i class="bx bx-mobile-alt bg-6610f2"></i>
                    <h3>{{ "specialized.pwa.title" | translate }}</h3>
                    <p>
                        {{ "specialized.pwa.text" | translate }}
                    </p>
                </div>
            </div>
            <div class="mb-4 col-lg-4 col-md-6">
                <div
                    class="features-box-one wow animate__animated animate__fadeInLeft"
                    data-wow-delay=".6s"
                >
                    <i class="bx bx-briefcase bg-ffb700"></i>
                    <h3>{{ "specialized.erp.title" | translate }}</h3>
                    <p>
                        {{ "specialized.erp.text" | translate }}
                    </p>
                </div>
            </div>
            <div class="mb-4 col-lg-4 col-md-6">
                <div
                    class="features-box-one wow animate__animated animate__fadeInUp"
                    data-wow-delay=".2s"
                >
                    <i class="bx bx-data bg-fc3549"></i>
                    <h3>{{ "specialized.database.title" | translate }}</h3>
                    <p>
                        {{ "specialized.database.text" | translate }}
                    </p>
                </div>
            </div>
            <div class="mb-4 col-lg-4 col-md-6">
                <div
                    class="features-box-one wow animate__animated animate__fadeInUp"
                    data-wow-delay=".4s"
                >
                    <i class="bx bx-git-branch bg-00d280"></i>
                    <h3>{{ "specialized.cicd.title" | translate }}</h3>
                    <p>
                        {{ "specialized.cicd.text" | translate }}
                    </p>
                </div>
            </div>
            <div class="mb-4 col-lg-4 col-md-6">
                <div
                    class="features-box-one wow animate__animated animate__fadeInUp"
                    data-wow-delay=".6s"
                >
                    <i class="bx bx-search-alt bg-ff612f"></i>
                    <h3>{{ "specialized.seo.title" | translate }}</h3>
                    <p>
                        {{ "specialized.seo.text" | translate }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="projects" class="team-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>{{ "projects.sectionTitle" | translate }}</h2>
        </div>
        <div class="row">
            <div
                class="col-lg-4 col-sm-6"
                *ngFor="let project of projects; let i = index"
            >
                <div
                    class="single-team-box wow animate__animated animate__fadeInUp"
                    [attr.data-wow-delay]="0.1 * (i + 1) + 's'"
                >
                    <div
                        class="image"
                        (click)="openModal(i)"
                        style="cursor: pointer"
                    >
                        <img
                            [src]="project.image"
                            [alt]="
                                ('projects.items.' +
                                    project.slug +
                                    '.title') | translate
                            "
                        />
                        <ul class="social" *ngIf="project.link">
                            <li>
                                <a [href]="project.link" target="_blank"
                                    ><i class="bx bxl-github"></i
                                ></a>
                            </li>
                        </ul>
                    </div>
                    <div class="content">
                        <h3>
                            {{
                                ("projects.items." +
                                    project.slug +
                                    ".title") | translate
                            }}
                        </h3>
                        <span>{{
                            ("projects.items." +
                                project.slug +
                                ".category") | translate
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="contact" class="free-trial-area ptb-150 bg-f4f5fe">
    <div class="container">
        <div class="section-title">
            <h2>{{ "contact.title" | translate }}</h2>
            <p>
                {{ "contact.subtitle" | translate }}
            </p>
        </div>
        <div class="row align-items-center justify-content-center">
            <div class="col-lg-4 col-md-6">
                <a
                    (click)="onEmailClick('contact')"
                    href="mailto:manda.ravalison@gmail.com"
                    class="single-contact-info d-block"
                >
                    <i class="bx bx-envelope"></i>
                    <h3>{{ "contact.email" | translate }}</h3>
                    <p>manda.ravalison&#64;gmail.com</p>
                </a>
            </div>
            <div class="col-lg-4 col-md-6">
                <a
                    (click)="onSocialClick('linkedIn')"
                    href="https://www.linkedin.com/in/manda-ravalison"
                    target="_blank"
                    class="single-contact-info d-block"
                >
                    <i class="bx bxl-linkedin-square"></i>
                    <h3>{{ "contact.linkedIn" | translate }}</h3>
                    <p>manda-ravalison</p>
                </a>
            </div>
            <div class="col-lg-4 col-md-6">
                <a
                    (click)="onSocialClick('github')"
                    href="https://github.com/mandarvl"
                    target="_blank"
                    class="single-contact-info d-block"
                >
                    <i class="bx bxl-github"></i>
                    <h3>{{ "contact.github" | translate }}</h3>
                    <p>mandarvl</p>
                </a>
            </div>
        </div>
    </div>
    <div class="shape10" aria-hidden="true">
        <img src="assets/img/shape/shape10.png" alt="image" loading="lazy" />
    </div>
    <div class="shape11" aria-hidden="true">
        <img src="assets/img/shape/shape7.png" alt="image" loading="lazy" />
    </div>
    <div class="shape12" aria-hidden="true">
        <img src="assets/img/shape/shape11.png" alt="image" loading="lazy" />
    </div>
    <div class="shape13" aria-hidden="true">
        <img src="assets/img/shape/shape12.png" alt="image" loading="lazy" />
    </div>
</section>

<!-- Project Image Modal -->
<div
    class="project-modal"
    [class.active]="modalActive"
    *ngIf="modalActive"
    (click)="closeModal()"
>
    <div class="modal-content" (click)="$event.stopPropagation()">
        <owl-carousel-o [options]="customOptions">
            <ng-template carouselSlide *ngFor="let project of projects">
                <div class="container">
                    <div class="project-slide">
                        <div class="slide-header row align-items-center">
                            <div class="col">
                                <div class="slide-caption">
                                    <h3>
                                        @if (project.link; as link) {
                                            <a [href]="link" target="_blank"
                                                >{{
                                                    ("projects.items." +
                                                        project.slug +
                                                        ".title") | translate
                                                }}
                                                <i class="bx bx-link"></i
                                            ></a>
                                        } @else {
                                            {{
                                                ("projects.items." +
                                                    project.slug +
                                                    ".title") | translate
                                            }}
                                        }
                                    </h3>
                                    <p class="mb-0">
                                        {{
                                            ("projects.items." +
                                                project.slug +
                                                ".category") | translate
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div class="col-auto">
                                <span class="close-btn" (click)="closeModal()"
                                    ><i class="bx bx-x"></i
                                    ><span class="d-none d-md-inline">{{
                                        "modal.close" | translate
                                    }}</span></span
                                >
                            </div>
                        </div>
                    </div>
                    <img
                        [src]="project.image"
                        [alt]="
                            ('projects.items.' +
                                project.slug +
                                '.title') | translate
                        "
                    />
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</div>
